// views/Admin/Statistics/components/Charts/BeaconCharts/QrScans/QrScansCharts.tsx
import { useEffect, useState, useCallback } from 'react';
import { Beacon } from '../../../../../../../Entities';
import Loading from '../../../../../../../components/common/Loading/Loading';
import QrScansByDaysChart from './QrScansByDaysChart/QrScansByDaysChart';
import QrScansByHoursChart from './QrScansByHoursChart/QrScansByHoursChart';
import styles from './QrScansCharts.module.css';

const QrScansCharts = () => {
  const [table, setTable] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const getTable = useCallback(async () => {
    try {
      setTable(await Beacon.getStats('qr_scans'));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getTable();
  }, [getTable]);

  if (loading) return <Loading />;
  if (!table) return <h1>Fetch error</h1>;

  return (
    <div className={styles.chartSection}>
      <h2>7 days Beacon statistics</h2>
      <div className={styles.chart}>
        <QrScansByDaysChart table={table} />
      </div>
      <div className={styles.chart}>
        <QrScansByHoursChart table={table} />
      </div>
    </div>
  );
};

export default QrScansCharts;
